/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolSportsMotorsportsIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-sports-motorsports"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M14.68 20.05L1.3 20.05Q1.3 20.05 1.29 20.04Q1.27 20.02 1.27 20.02Q1.27 18.85 1.29 17.82Q1.3 16.8 1.35 16L9.93 16Q11.88 16 13.28 14.61Q14.68 13.22 14.68 11.2Q14.68 9.75 13.84 8.55Q13 7.35 11.65 6.8L8.3 5.45Q9.72 4.72 11.24 4.34Q12.75 3.95 14.35 3.95Q17.77 3.95 20.25 6.28Q22.73 8.6 22.73 12Q22.73 15.35 20.38 17.7Q18.02 20.05 14.68 20.05ZM1.82 13.35Q2.33 11.63 3.31 10.05Q4.3 8.47 5.7 7.22L10.68 9.25Q11.32 9.5 11.68 10.03Q12.03 10.55 12.03 11.2Q12.03 12.13 11.4 12.74Q10.78 13.35 9.85 13.35Z" fill={color} />
    </svg>
  );
}
